import { render, staticRenderFns } from "./ShowTransportData.vue?vue&type=template&id=1b95196e"
import script from "./ShowTransportData.vue?vue&type=script&lang=js"
export * from "./ShowTransportData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports